import { z } from "zod";
import { BladeCommonSchema } from "../../../../types";
import { BladeHeaderSchema } from "../../../../schemas/BladeHeader";
import { BackdropSchema } from "../../../../schemas/Backdrop";
import { LinkItemSchema } from "../../../../schemas/LinkItem";
import { ImageMediaSchema } from "../../../../schemas/Media";
const RegionItemSchema = z.object({
    title: z.string(),
    region: z.string(),
});
export const PsRegionSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    psRegions: z.array(RegionItemSchema).optional(),
    buttons: z.array(LinkItemSchema).optional(),
});
export const PsWarningSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    buttons: z.array(LinkItemSchema).optional(),
});
export const RatingSchema = z.object({
    ratingImage: ImageMediaSchema,
    ratingText: z.string().optional(),
});
export const BetaKeyRedemptionSchema = z.object({
    xboxKeyHeader: z.string().optional(),
    psBetaKeyHeader: z.string().optional(),
    xboxRedeemButtonText: z.string().optional(),
    psRedeemButtonText: z.string().optional(),
    copySuccessText: z.string().optional(),
});
export const BetaRegistrationMastheadBladeSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    backdrop: BackdropSchema.optional(),
    buttons: z.array(LinkItemSchema).optional(),
    campaignID: z.string(),
    psRegionModal: PsRegionSchema.optional(),
    psWarningModal: PsWarningSchema.optional(),
    betaKeyRedemption: BetaKeyRedemptionSchema.optional(),
    gameIcon: ImageMediaSchema.optional(),
    platformIcons: z.array(ImageMediaSchema).optional(),
    rating: RatingSchema.optional(),
});
//# sourceMappingURL=index.js.map